// extracted by mini-css-extract-plugin
export default {"rotating":"loading_spinner___rotating___c29a8196"};